const angular = require('angular');
const ngMessages = require('angular-messages');
const ngSanitize = require('angular-sanitize');
const uiRouter = require('angular-ui-router');
const restangular = require('restangular'); // eslint-disable-line no-unused-vars
require('dialog-polyfill');
const olyDialog = require('oly-dialog');

const olyCommonModule = require('../olycommon/olycommon.module');
const analyticsModule = require('../analytics/analytics.module');

const wowCommonModuleName = 'wowApp.common';

angular.module(wowCommonModuleName, [
    analyticsModule,
    olyCommonModule,
    ngMessages,
    ngSanitize,
    uiRouter,
    'restangular',
    olyDialog,
]);

// Components

// high priority modules
require('./bootstrap');
require('./config');
require('./feature');
require('./settings');

require('./bootstrap');
require('./breakpoints');
require('./button');
require('./copyright');
require('./deliverypass');
require('./dialog');
require('./dynamiccontent');
require('./emailvalidator');
require('./namelengthwarnings');
require('./eventrecorder');
require('./errorpage');
require('./filters');
require('./footer');
require('./heartbeat');
require('./lists');
require('./loadingindicator');
require('./loyalty/loyalty-points-calculator');
require('./matchexistingtextvalidator');
require('./mobilephonevalidator');
require('./pagemetadata');
require('./pastshops');
require('./paypal');
require('./products');
require('./savedlists');
require('./shoppagestate');
require('./smallformatmenu');
require('./socialmedia');
require('./togglebutton');
require('./togglebuttongroup');
require('./unsubscribeedm');
require('./userpreference');
require('../olycommon/localStorageWrapper');

module.exports = wowCommonModuleName;



// WEBPACK FOOTER //
// ./src/common/common.module.js